import React from 'react';
import { Tooltip, OverlayTrigger} from 'react-bootstrap';

const ShortenedText = ({ shortText, longText, centered}) =>{
  const toolTip = (
    <Tooltip id="tooltip">
      <p>{longText}</p>
    </Tooltip>
  )

  return(
    <span className={`flex align-items-center ${centered ? "justify-center" : ""}`}>
      <span style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}>{shortText}</span>
      <OverlayTrigger placement="top" overlay={toolTip}>
        <i className="fa fa-info-circle text-primary"></i>
      </OverlayTrigger>
    </span>
  )
}

export default ShortenedText;
